<div *ngIf="form" [formGroup]="form">
  <!-- Filters Grid -->
  <div class="filters-container">
    <div 
      *ngFor="let filter of getSortedFilters()" 
      class="filter-item"
      [style.width]="filter.width || 'auto'"
      [style.display]="isFieldVisible(filter) ? 'block' : 'none'">
      
      <!-- Filter Label -->
      <label class="filter-label">
        {{ filter.label }}
        <span *ngIf="filter.required" class="required">*</span>
      </label>

      <!-- Text Input -->
      <input 
        *ngIf="filter.type === FilterType.TEXT || filter.type === FilterType.EMAIL || filter.type === FilterType.NUMBER"
        nbInput
        [type]="filter.type"
        [placeholder]="filter.placeholder || filter.label"
        [formControlName]="filter.key"
        class="filter-input">

      <!-- Textarea -->
      <textarea 
        *ngIf="filter.type === FilterType.TEXTAREA"
        nbInput
        [placeholder]="filter.placeholder || filter.label"
        [formControlName]="filter.key"
        class="filter-input">
      </textarea>

      <!-- Select Dropdown -->
      <nb-select 
        *ngIf="filter.type === FilterType.SELECT"
        [placeholder]="filter.placeholder || filter.label"
        [formControlName]="filter.key"
        class="filter-input">
        <nb-option *ngFor="let option of filter.options" 
                   [value]="option.value" 
                   [disabled]="option.disabled">
          {{ option.label }}
        </nb-option>
      </nb-select>

      <nb-select 
        *ngIf="filter.type === FilterType.GROUP_SELECT"
        [placeholder]="filter.placeholder || filter.label"
        [formControlName]="filter.key"
        fullWidth
        class="filter-input">
        <nb-option-group 
          *ngFor="let group of filter.groupedOptions"
          [title]="group.name"
          style="font-weight: bold;">
          <nb-option 
            *ngFor="let option of group.options"
            [value]="option.value"
            [disabled]="option.disabled">
            {{ option.label }}
          </nb-option>
        </nb-option-group>
      </nb-select>
      
      <!-- Multi Select -->
      <nb-select 
        *ngIf="filter.type === FilterType.MULTI_SELECT"
      [placeholder]="filter.placeholder || filter.label"
      [formControlName]="filter.key"
      multiple
      class="filter-input">
      <nb-option *ngFor="let option of filter.options" 
                 [value]="option.value" 
                 [disabled]="option.disabled">
        {{ option.label }}
      </nb-option>
    </nb-select>

    <!-- Date Picker -->
    <ng-container *ngIf="filter.type === FilterType.DATE">
      <input 
        nbInput
        [nbDatepicker]="datePicker"
        [placeholder]="filter.placeholder || filter.label"
        [formControlName]="filter.key"
        class="filter-input">
      <nb-datepicker #datePicker></nb-datepicker>
    </ng-container>

    <!-- Date Range (simplified version) -->
    <ng-container *ngIf="filter.type === FilterType.DATE_RANGE">
      <div class="date-range-container">
        <input 
          nbInput
          [nbDatepicker]="fromDatePicker"
          placeholder="From"
          [formControlName]="filter.key + '_from'"
          class="filter-input date-range-input">
        <nb-datepicker #fromDatePicker></nb-datepicker>
        
        <input 
          nbInput
          [nbDatepicker]="toDatePicker"
          placeholder="To"
          [formControlName]="filter.key + '_to'"
          class="filter-input date-range-input">
        <nb-datepicker #toDatePicker></nb-datepicker>
      </div>
    </ng-container>

    <!-- Checkbox -->
    <nb-checkbox 
      *ngIf="filter.type === FilterType.CHECKBOX"
      [formControlName]="filter.key">
      {{ filter.placeholder || filter.label }}
    </nb-checkbox>

    <!-- Radio Group -->
    <nb-radio-group 
      *ngIf="filter.type === FilterType.RADIO"
      [formControlName]="filter.key">
      <nb-radio 
        *ngFor="let option of filter.options" 
        [value]="option.value"
        [disabled]="option.disabled">
        {{ option.label }}
      </nb-radio>
    </nb-radio-group>

    <!-- Error Display -->
    <div *ngIf="form.get(filter.key)?.invalid && form.get(filter.key)?.touched" 
         class="error-message">
      <small>{{ filter.label }} is required</small>
    </div>
  </div>
  </div>

  <div class="clear-filters-section" *ngIf="showClearButton">
    <div class="filters-separator"></div>
    <div class="clear-filters-container">
      <pv-action-button
        [label]="'shared.components.custom_list_layout.clear_filters' | translate"
        [icon]="'times-circle'"
        (buttonClick)="onClearFilters()">
      </pv-action-button>
    </div>
  </div>
</div>
